import React from "react";
import { Text } from "../../../atoms/Text/Text";
import { User } from "../../../models/User";
import moment from "moment";
import classNames from "classnames";

import { FriendTabs } from "../../../services/Friend/FriendService";
import { ChallengeStatsByDateModel } from "../../../models/Challenge";

import styles from "./FriendChallenge.css";

type RenderReceivedChallengesProps = {
  list: ChallengeStatsByDateModel[];
  user: User;
  tabId: FriendTabs;
  isOpened: boolean;
  onTabSelect?: (tab: FriendTabs, gameId?: number) => void;
};

export class RenderReceivedChallenges extends React.Component<RenderReceivedChallengesProps> {
  state = { activeViewMore: false };

  handleViewMore = () => {
    this.setState({
      activeViewMore: !this.state.activeViewMore,
    });
  };

  renderReceivedChallengesList() {
    const { list, onTabSelect } = this.props;

    return (
      <table className={styles.challenges_table}>
        <thead>
          <tr>
            <th>Game Date</th>
            <th align="center">
              <span className={styles.hidden_mobile}>Challenges Received</span>
              <span className={styles.hidden_desktop}>Challenges</span>
            </th>
            <th align="center">Wagers</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list && list.map((record: ChallengeStatsByDateModel, i) => (
            <tr key={i} className={record.friendActivity && styles.show_activity_badge}>
              <td>{moment(record.date).format("MMMM D")}</td>
              <td align="center">{record.totalChallenges || 0}</td>
              <td align="center">{record.wagers || 0}</td>
              <td>
                <button
                  onClick={() =>
                    onTabSelect(
                      FriendTabs.ViewReceivedChallengeByDate,
                      record.puzzleId
                    )
                  }
                  type="button"
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    const { tabId, isOpened } = this.props;

    return (
      <div
        role="tabpanel"
        id={tabId}
        className={classNames({ [styles.hiddenFriendTable]: !isOpened })}
        aria-labelledby={`tab${tabId}`}
      >
        <Text
          className={classNames(styles.challenge_cta, {
            [styles.open]: this.state.activeViewMore,
          })}
        >
          You have received Challenges, maybe even with some wagers, from your
          friends. They are marked with a red circle. There is no max on the
          number of Challenges and/or Wagers you can receive. So, play away and
          score big!
        </Text>
        <span
          className={classNames(styles.viewMore, {
            [styles.open]: this.state.activeViewMore,
          })}
          onClick={() => this.handleViewMore()}
        >
          View {this.state.activeViewMore ? "Less" : "More"}
        </span>

        {this.renderReceivedChallengesList()}
      </div>
    );
  }
}